import clsx from 'clsx'
import React, { HTMLAttributeAnchorTarget, useMemo } from 'react'

import { formatDate, parseDate } from '@/util'

export type LineTagType = 'success' | 'error' | 'info' | 'none' | 'primary' | 'warning'

interface LineItemProps {
  booleanCheck?: boolean
  dateValue?: boolean
  emptyCheck?: boolean
  label: string
  last?: boolean
  link?: {
    href: string
    target: HTMLAttributeAnchorTarget | undefined
  }
  tag?: LineTagType
  value?: number | string | boolean | null
  valueClassName?: string
}

export function LineItem({
  label,
  value,
  last = false,
  tag = 'none',
  emptyCheck = false,
  valueClassName = '',
  booleanCheck = false,
  dateValue = false,
  link,
}: LineItemProps) {
  const variantClassName = useMemo(() => {
    return TagVariantStyles[tag]
  }, [tag])

  if (emptyCheck && (value == null || value == undefined)) {
    return null
  }

  function valueToDisplay(value) {
    if (booleanCheck) {
      return !!value ? 'Yes' : 'No'
    }

    const type = typeof value
    let displayVal = ''

    switch (type) {
      case 'undefined':
        displayVal = 'N/A'
        break
      case 'boolean':
        displayVal = value ? 'Yes' : 'No'
        break
      default:
        displayVal = value
    }
    if (dateValue && value) {
      displayVal = formatDate(parseDate(value), 'MM/dd/yyyy') || ''
    }

    return displayVal
  }

  return (
    <div className={`${last ? '' : ' border-b border-secondary '} flex w-full items-center justify-between py-2`}>
      <div className="whitespace-nowrap py-2 text-sm leading-140">{label}</div>
      <div
        className={clsx(
          'overflow-auto rounded px-3 py-2 text-right text-sm capitalize leading-140',
          variantClassName,
          valueClassName,
        )}
      >
        {link ? (
          <a className="text-action-primary underline" href={link.href} rel="noreferrer" target={link.target}>
            {value}
          </a>
        ) : (
          <p>{valueToDisplay(value)}</p>
        )}
      </div>
    </div>
  )
}

export const TagVariantStyles = {
  success: 'tag-green-light text-semantic-success',
  error: 'bg-text-semantic-error text-icon-semantic-white',
  info: 'tag-grey-light',
  warning: 'tag-yellow-light text-yellow-300',
  none: '',
  primary: 'tag-green-dark text-semantic-white',
}
